export default {"src":"/newStatic/_next/static/media/fact-3.51cc8ec9.svg","height":23,"width":36};